const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			tags: true
		},
		buttonContext: 'news',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: true,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'cms_news',
		rowActionsProperties: {
			// colWidth: '43px'
		},
		rowActions: {
			delete: true
		},
	},

	model: {
		actionInEffect: '',
		actionModeInEffect: '',
		postProcessingOptions: {},
		resourceFilters: {
			order: [{
				fieldCode: 'startTS',
				direction: 'desc'
			},{
				fieldCode: 'title',
				direction: 'asc'
			}]
		}
	},

	methods: {

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){
			// TODO: CLEANUP after feature is done and dusted
			// split mailingListSegment combined field into mailingListID and segmentID if necessary
			// if(((resourceFilters || {}).filters || {}).mailingListSegment){
			// 	var mailingListSegment = String(resourceFilters.filters.mailingListSegment || '').split('|');
			// 	resourceFilters.filters.mailingListID = mailingListSegment[0] || undefined;
			// 	resourceFilters.filters.segmentID = mailingListSegment[1] || undefined;
			// }
			//
			// // set subscriber limiting mailingID uf necessary
			// if(actionKey === 'refreshResources' && this.model.limitSubscribersToMailingID === false){
			// 	var subscriberSpecifics = this.getResourceRegisterContent('subscriberSpecifics') || {};
			// 	this.model.limitSubscribersToMailingID = subscriberSpecifics.mailingID || 0;
			// 	this.model.postProcessingOptions = subscriberSpecifics.postProcessingOptions || {};
			// 	if((this.model.postProcessingOptions || {}).isPostProcessing){
			// 		this.config.rowActions.delete = false;
			// 	}
			// }
			//
			// if(actionKey !== 'load_mailingListAdditionalFields' && actionKey !== 'delete_mailings_subscriber' && this.model.limitSubscribersToMailingID) {
			// 	if(!resourceFilters.filters) resourceFilters.filters = {}
			// 	resourceFilters.filters.mailingID 				= this.model.limitSubscribersToMailingID;
			// 	resourceFilters.filters.postProcessingOptions 	= this.model.postProcessingOptions;
			// }

			return resourceFilters;
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		showInsert: function(rowID, rowData, buttonMode){
			this.performAndStoreAction(
				'showInsert_news_inEffect',
				this.prepareAction('showInsert_news')
			);
		},

		showEdit: function(rowID, rowData, buttonMode){
			var entityPrefix = '';
			if(this.hasRoleOption('showIDs')){
				entityPrefix = '#' + rowID + ' - ' + entityPrefix;
			}
			var baseActionKey = 'showEdit_news'
			var actionKey = baseActionKey;
			actionKey += '_' + rowID;
			var rowAttributes = (rowData || {}).attributes || {}

			// re-perform action if necessary
			if(this.actions[actionKey]){
				return this.performAction(actionKey, {
					// TODO: POI
					// focusTabSecret: (data || {}).startWithRegisterSecret || 'newsContent'
				});
			}
			else if(this.actions[baseActionKey]){
				// var node = this.getNode(nodeIndex);
				return this.performAndStoreAction(
					actionKey,
					this.prepareAction(baseActionKey, undefined, {
						entityParent: utils.replace(rowData, { resourceID: rowID }),
						routeTreeParent: {
							resourceID: rowAttributes.routeID
						},
						tabOptions: {
							title: entityPrefix + rowAttributes.title,
							icon: 'fi fi-news'
						}
					}, {
						// skipErrorHandling:  true,
						// source: {
						// 	tabContent: {
						// 		componentData: {
						// 			config: {
						// TODO: POI
						// 				// startWithRegisterSecret: (data || {}).startWithRegisterSecret || 'routeContent'
						// 			}
						// 		}
						// 	}
						// }
					}),
					false
					// TODO: error handling needed since the errorHandlers of the components (and this one's too) may handle this one?!?
				// );
				// ).fail(function(context){
				// 	console.log('table fail', context)
				// // 	// news entry not available?
				// // 	if(
				// // 		((context || {}).component || {}).componentClass === 'templates_propertiesForms_newsPropertiesForm' &&
				// // 		context.error &&
				// // 		context.error.statusCode === 404 &&
				// // 		context.error.errorCode === 'REQUEST_HANDLER_RESOURCE_NOT_FOUND_ERROR_2'
				// // 	){
				// // 		return self.performAction(
				// // 			self.prepareAction('message', undefined, {
				// // 				messageDisplay: {
				// // 					message: 'error:news.table.showEditMissingEntry'
				// // 				}
				// // 			}, {
				// // 				rollbackContext: context,
				// // 				statusControllerLoadingMessage: '',
				// // 				statusControllerSavingMessage:  ''
				// // 			})
				// // 		);
				// // 	}
				// // 	return context
				);
			}

			return utils.promise.reject();
		},

		delete: function(rowID, rowData, buttonMode){
			var self = this;

			if(rowID){
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__('hint.delete.really.news.title'),
						message:    storage.__('hint.delete.really.news.message')
					}
				).then(context => {
					if (context.decision.type === 'yes') {

						return this.performAction(
							this.prepareAction('delete_news', rowID)
						).then(context => {
							// refresh news list
							this.refreshData();
							this.callHandler('onDeleteNews', [rowID])
							return context;
						});
					}

					return utils.promise.reject();
				});
			}

			return utils.promise.reject(new Error('DELETE SUBSCRIBER MISSING SUBSCRIBER_ID'));
		},

		handleError: function(context){
			const baseError = utils.extractBaseError(context.error);

			// news entry could not be loaded since it is missing
			if(
				((context || {}).component || {}).componentClass === 'templates_propertiesForms_newsPropertiesForm' &&
				baseError.statusCode === 404 &&
				baseError.errorCode === 'REQUEST_HANDLER_RESOURCE_NOT_FOUND_ERROR_2'
			){
				// prevent multiple error messages from being shown at once.
				this.skipFurtherErrorHandling()
				this.refreshData(true);
				return this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:news.table.showEdit.missingNewsEntry'
						}
					}, {
						rollbackContext: context,
						statusControllerLoadingMessage: '',
						statusControllerSavingMessage:  ''
					})
				);
			}

			// routeContentTree of route could not be loaded since it is missing
			if(
				((context || {}).component || {}).componentClass === 'templates_routeContentTrees_routeContentTrees' &&
				baseError.statusCode === 404 &&
				baseError.errorCode === 'COMPONENT_TREE_BUILDER_ERROR_7'
			){
				// prevent multiple error messages from being shown at once.
				this.skipFurtherErrorHandling()
				this.refreshData(true);
				return this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:news.table.showEdit.missingRoute'
						}
					}, {
						rollbackContext: context,
						statusControllerLoadingMessage: '',
						statusControllerSavingMessage:  ''
					})
				);
			}

			context.errorUnhandled = true;
			return utils.promise.resolve(context);
		},


		customClickHandler: function(event){
			var bubble = $(event.target).closest('.bubble')
			var tagsColumn = $(event.target).closest('.fieldOf_tags')
			if(bubble.length > 0 && tagsColumn.length > 0){
				var tagKey = bubble.data('tagKey');
				var tagParts = String(tagKey || '').split('_') || [];
				var categoryID = tagParts[0] || 0
				var categoryDataID = tagParts[1] || 0
				if(categoryID && categoryDataID){
					this.triggerClosest('colTagsBubbleSelected', {
						categoryID,
						categoryDataID
					}, 'templates_news_controller')
					return true;
				}
			}

			return false;
		},

		onAfterLazyLoad: function(errorOccurred){
			if(!errorOccurred){
				this.updateBubbleHighlighting()
			}
		},

		updateBubbleHighlighting: function(){
			var highlightTagBubbles = ((this.model.resourceFilters || {}).filters || {}).tags || [];
			this.$.find('.fieldOf_tags .bubble').removeClass('highlighted');
			if(highlightTagBubbles.length > 0){
				this.$.find(highlightTagBubbles.map(tagKey => `.fieldOf_tags .bubble[data-tag-key="${tagKey}"]`).join(',')).addClass('highlighted');
			}
		},
	},

	hooks: {
		_attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_news_controller', function(controller){
					self.model.controller = controller
				});
			}

			this.updateBubbleHighlighting()
		},

		async onDecision($element, options){
			if(options.decisionComponent.hasClass('base_modal_modal')){
				if(options.decisionType === 'cancel'){
					await options.decisionComponent.hide()
				} else if(options.decisionComponent.hasClass('container_templates_propertiesForms_newsPropertiesForm')){
					let propertiesForm
					options.decisionComponent.find('templates_propertiesForms_newsPropertiesForm', c => propertiesForm = c)
					if(propertiesForm){
						const result = await propertiesForm.submit()
						const data = ((result || {}).response || {}).data || {}
						const attributes = data.attributes || {}
						const _primaryKey = attributes[data.primaryKey || 'id']

						await options.decisionComponent.hide()
						this.refreshData()

						if(_primaryKey){
							this.showEdit(_primaryKey, data)
						}
					}
				}
			}
		}
	},

	handlers: [{
		name: 'onSubmitDone',
		componentClass: 'templates_propertiesForms_routePropertiesForm',
		handle: function(callerComponent, nodeData, insertPerformed){
			callerComponent.closest('templates_news_controller', () => {
				this.refreshData();
			}, true)
		}
	},{
		name: 'onSubmitDone',
		componentClass: 'templates_propertiesForms_newsPropertiesForm',
		handle: function(callerComponent, nodeData, insertPerformed){
			callerComponent.closest('templates_news_controller', () => {
				this.refreshData();
			}, true)
		}
	}]
}
